/** The tour miniature with the console's real icons. See tour-layout.ts. */
import { Icon } from './icons.tsx';
import { TourLayoutFrame, type TourLayout } from './tour-layout.ts';

export function TourLayoutView({ layout }: { layout: TourLayout }) {
  return <TourLayoutFrame layout={layout} renderIcon={(name) => <Icon name={name} className="glyph" />} />;
}
